/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SeedNextBestActionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/next_best_action_messages.pb'
import {SeedNextBestActionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/next_best_action_messages.pb'


export const seedNextBestAction = (request: SeedNextBestActionRequest, options?: CashRequestOptions) => post<SeedNextBestActionRequest, SeedNextBestActionResponse>("/2.0/cash/seed-next-best-action", request, {...options, rejectOnError: true })